export default function TermsPage() {
  return (
    <div className="flex flex-col justify-start  w-full py-10 px-5 gap-2 pb-32">
      <h1 className="text-4xl font-bold">Terms and Conditions</h1>
      <div>
        Welcome to ManUp (“we”, “us”, “our”), a game-based platform designed to
        help users improve their communication, confidence, and mindset through
        interactive scenarios and challenges. Please read these Terms and
        Conditions (“Terms”) carefully before using ManUp (the “Game” or
        “Service”). By accessing or using the Service, you agree to be bound by
        these Terms. If you do not agree with any part of the Terms, you may not
        access or use the Service.
      </div>
      <h2 className="text-2xl font-bold">1. Eligibility</h2>
      <div>
        You must be at least 13 years old to use ManUp. By using the Service,
        you represent and warrant that you meet this age requirement.
      </div>
      <h2 className="text-2xl font-bold">2. Use of the Service</h2>
      <div>
        ManUp is provided for informational and entertainment purposes only. You
        agree to use the Service responsibly and in accordance with all
        applicable laws and these Terms. You agree not to: Use the Service for
        any unlawful purpose. Attempt to reverse engineer, decompile, or hack
        the Game. Harass, threaten, or abuse other users or the developers. Use
        bots, scripts, or automated tools to access the Service.
      </div>
      <h2 className="text-2xl font-bold">3. Subscriptions and Purchases</h2>
      <div>
        Some features of ManUp may require payment or subscription. All
        purchases are final and non-refundable unless otherwise required by law.
        By purchasing a subscription or in-game items (e.g. “Hearts”, “PRO”
        access), you agree to the pricing, renewal terms, and billing procedures
        outlined at the point of purchase. You may cancel your active
        subscription by navigating to your Profile tab, and clicking the Manage
        Subscription button.
      </div>
      <h2 className="text-2xl font-bold">4. User Content</h2>
      <div>
        You may interact with and submit content (e.g. scenario responses, input
        text). You retain ownership of your content but grant ManUp a worldwide,
        non-exclusive, royalty-free license to use, reproduce, and display your
        content for the purpose of operating and improving the Service. We
        reserve the right to moderate or remove content that violates our
        policies.
      </div>
      <h2 className="text-2xl font-bold">5. Intellectual Property</h2>
      <div>
        All content, design, and functionality of the Game are the intellectual
        property of ManUp or its licensors. You may not reproduce, distribute,
        or create derivative works without explicit permission.
      </div>
      <h2 className="text-2xl font-bold">6. Disclaimer</h2>
      <div>
        ManUp is not a substitute for professional mental health, relationship,
        or psychological advice. While the Game is designed to simulate
        real-life interactions, results will vary and no specific outcome is
        guaranteed. You acknowledge and agree that use of the Game is at your
        own risk.
      </div>
      <h2 className="text-2xl font-bold">7. Limitation of Liability</h2>
      <div>
        To the fullest extent permitted by law, ManUp shall not be liable for
        any direct, indirect, incidental, or consequential damages arising from
        your use of the Service.
      </div>
      <h2 className="text-2xl font-bold">8. Changes to Terms</h2>
      <div>
        We reserve the right to modify these Terms at any time. Changes will be
        posted with an updated effective date. Continued use of the Game after
        such changes constitutes your acceptance of the new Terms.
      </div>
      <h2 className="text-2xl font-bold">9. Termination</h2>
      <div>
        We may suspend or terminate your access to the Service at any time for
        violation of these Terms or any other behavior deemed harmful to the
        community or platform.
      </div>
      <h2 className="text-2xl font-bold"> 10. Contact</h2>
      <div>
        For questions or concerns regarding these Terms, you may contact us at:
        <a href="mailto:support@manupgame.com" className="underline">
          support@manupgame.com
        </a>
      </div>
    </div>
  );
}
